import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { UserPathBlob } from 'src/api/userPath/types';
import { CompletedWordlistImage } from 'src/apps/Path/CompletedWordlistImage';
import * as S from './styles';

const msgs = defineMessages({
  completed: { id: 'blob_path_completed', defaultMessage: 'Completed' },
  progress: {
    id: 'blob_eos_completed_wordlist_progress',
    defaultMessage: '{count} of {count} words completed',
  },
});

export const CompletedWordlist: FC<{ wordlist: UserPathBlob }> = ({ wordlist }) => {
  const intl = useIntl();
  const count = intl.formatNumber(wordlist.numberOfLearnables);

  return (
    <S.Card role="status" data-testid="blob-eos-completed-wordlist">
      <CompletedWordlistImage blob={wordlist} />
      <S.Copy>
        <S.Title dir="auto">{wordlist.title}</S.Title>
        <S.Completed>{intl.formatMessage(msgs.completed)}</S.Completed>
      </S.Copy>
      <S.Progress
        role="progressbar"
        aria-label={intl.formatMessage(msgs.progress, { count: wordlist.numberOfLearnables })}
        aria-valuemin={0}
        aria-valuemax={wordlist.numberOfLearnables}
        aria-valuenow={wordlist.numberOfLearnables}
      >
        <S.Count dir="ltr">{`${count}/${count}`}</S.Count>
        <S.Track>
          <S.Fill />
        </S.Track>
      </S.Progress>
    </S.Card>
  );
};
